import React from "react";
import {
  Box,
  Button,
  Circle,
  Flex,
  Heading,
  Input,
  Select,
  Text,
} from "@chakra-ui/react";
import search from "../../../Assets/search.png";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import * as api from "../../../services/api";
import { authActions } from "../../../redux/actions";
import swAlert from "sweetalert2";

const Select_company = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (user.companyId) {
      navigate("/hiring/recruiter/active");
    }
  }, []);

  useEffect(() => {
    const getCompanies = async () => {
      const { data } = await api.getAllCompanies();

      setCompanies(data?.data);
    };

    getCompanies();
  }, []);

  const submitHandler = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!selectedCompany) {
      swAlert.fire({
        icon: "error",
        text: "Please select a company",
        timer: 1300,
      });
      return;
    }
    const response = await api.addCompanyToUser(selectedCompany, user.email);
    if (response.status === 200) {
      dispatch(authActions.updateUser());
      swAlert.fire({
        icon: "success",
        text: "Company selected successfully",
        timer: 1300,
      });
      window.location.href = "/hiring/recruiter/findtalent";
    }
  };

  return (
    <div>
      <Box>
        <Flex
          h="100vh"
          w="100vw"
          align="center"
          justify="center"
          flexDirection="column"
        >
          {/* Heading */}
          <Box>
            <Heading>Select Company</Heading>
            <Text mt={3}>Let’s Create Your Recruiter Account</Text>
          </Box>
          <Box mt={51}>
            {/* Comapny name */}
            <Flex mt={5} border="1px solid #B3B3B3" borderRadius={12}>
              <Flex
                align="center"
                w={[300, 300, 347, 347]}
                h={54}
                // border="1px solid"
                px={4}
                py={2}
                justify="space-between "
                borderRadius={12}
                bg={"#FAFAFA"}
              >
                <select
                  placeholder="Company name"
                  variant="unstyled"
                  fontSize={16}
                  className="custom_select"
                  style={{ width: "100%" }}
                  isRequired
                  value={selectedCompany}
                  onChange={(e) => setSelectedCompany(e.target.value)}
                >
                  <option value="" disabled selected hidden>
                    Select Company
                  </option>
                  {companies?.map((company) => (
                    <option
                      className="option_custom"
                      key={company._id}
                      value={company._id}
                    >
                      {company.companyName}
                    </option>
                  ))}
                </select>

                {/* <Circle>
                  <img src={search} alt="search" />
                </Circle> */}
              </Flex>
            </Flex>
          </Box>
          {/* Submit Button */}
          <Flex
            bg="#6C56FB"
            align="center"
            justify="center"
            _hover={{ bg: "#8E48FF" }}
            h={47}
            w={132}
            gap={2}
            borderRadius={12}
            mt={71}
            cursor="pointer"
            onClick={submitHandler}
          >
            <Text
              color="#FFFFFF"
              fontSize={20}
              fontWeight="500"
              fontFamily={"Roboto"}
            >
              Submit
            </Text>
          </Flex>
          {/* Register company */}
          <Text
            as="u"
            mt={4}
            fontSize={16}
            fontWeight={400}
            fontFamily={"Roboto"}
            cursor="pointer"
            color="#000000"
            onClick={() => {
              navigate("/hiring/recruiter/setupCompany");
            }}
          >
            Register my company
          </Text>

          <Text
            fontSize={14}
            fontWeight={400}
            fontFamily={"Roboto"}
            mt={4}
            color="#000000"
          >
            or
          </Text>

          <Text
            mt={2}
            fontSize={16}
            fontWeight={400}
            onClick={() => {
              dispatch(authActions.logout());
            }}
            fontFamily={"Roboto"}
            cursor={"pointer"}
            textDecor={"underline"}
          >
            Logout
          </Text>
        </Flex>
      </Box>
    </div>
  );
};
export default Select_company;
